@if (!filteredDatasource()) {
    <div
        class="cipo--overflow-x--hidden"
        role="status"
        [attr.aria-busy]="true"
        [attr.aria-label]="'a11y.fileExplorer.loadingFolders' | translate">
        @if (includeSearch()) {
            <div
                class="cipo--border--lite cipo--border-radius--sm cipo--height--55 p-x-sm m-b-md"
                fxLayout="row"
                fxLayoutAlign="start center">
                <ngx-skeleton-loader [theme]="{ width: '40%', height: '14px', margin: '0', display: 'block' }" />
            </div>
        }

        <div fxLayout="column" fxLayoutGap="16px">
            @for (row of skeletonRows; track $index) {
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6px" [style.padding-left.px]="row.indent">
                    <div fxLayout="row" fxLayoutAlign="center center" fxFlex="0 0 40px">
                        @if (row.hasChevron) {
                            <ngx-skeleton-loader
                                [theme]="{
                                    width: '16px',
                                    height: '16px',
                                    margin: '0',
                                    'border-radius': '3px',
                                    display: 'block',
                                }" />
                        }
                    </div>
                    <div fxFlex="none">
                        <ngx-skeleton-loader
                            [theme]="{
                                width: '20px',
                                height: '20px',
                                margin: '0',
                                'border-radius': '4px',
                                display: 'block',
                            }" />
                    </div>
                    <div fxFlex class="cipo--overflow--hidden">
                        <ngx-skeleton-loader
                            [theme]="{ width: row.width, height: '13px', margin: '0', display: 'block' }" />
                    </div>
                </div>
            }
        </div>
    </div>
} @else {
    @if (includeSearch()) {
        <mat-form-field class="cipo--width--full" appearance="outline">
            <mat-label>{{ "general.search" | translate }}</mat-label>
            <input matInput data-testid="folder-tree-search" [formControl]="searchControl" />
        </mat-form-field>
    }
    <cdk-tree
        #tree
        [attr.aria-label]="'a11y.fileExplorer.folderTree' | translate"
        [dataSource]="filteredDatasource()"
        [trackBy]="trackBy"
        [expansionKey]="expansionKey"
        [childrenAccessor]="getChildrenAccessor">
        <cdk-tree-node
            *cdkTreeNodeDef="let node"
            data-testid="folder-tree-node"
            [cdkTreeNodePadding]="node.level || 0"
            [attr.data-node-id]="node.id"
            [attr.data-node-key]="node.explorerKey"
            [attr.aria-label]="node.name"
            [attr.aria-selected]="node.explorerKey === selectedNode()?.explorerKey"
            [class.tree-node--selected]="node.explorerKey === selectedNode()?.explorerKey"
            [cdkTreeNodeTypeaheadLabel]="node.name"
            [isExpandable]="node.hasChildren"
            (activation)="selectNode(node)"
            (expandedChange)="onExpand(node, $event)">
            @let isExpanded = tree.isExpanded(node);
            @if (node.hasChildren) {
                <button
                    mat-icon-button
                    cdkTreeNodeToggle
                    [attr.aria-label]="'a11y.fileExplorer.toggleFolder' | translate: { name: node.name }">
                    <mat-icon class="material-symbols-outlined" aria-hidden="true">
                        {{ isExpanded ? "expand_more" : "chevron_right" }}
                    </mat-icon>
                </button>
            } @else {
                <div class="icon-placeholder"></div>
            }

            @if (node.isFolder) {
                @let isSelected = node.explorerKey === selectedNode()?.explorerKey;
                <div class="folder-icons">
                    @if (node.badge) {
                        <mat-icon class="badge-icon cipo-text--accent-500" aria-hidden="true">
                            {{ node.badge }}
                        </mat-icon>
                    }
                    <mat-icon
                        class="cipo-text--primary-900"
                        aria-hidden="true"
                        [class.material-symbols-outlined]="isSelected">
                        {{ isSelected ? "folder_open" : "folder" }}
                    </mat-icon>
                </div>
            } @else if (node.itemModuleId) {
                @let module = entityModule(node);
                <itv-module-icon [iconid]="module?.iconId" [color]="module?.color" />
            }

            <!-- Mouse affordance only. Keyboard activation is the treeitem's own `(activation)`; adding
                 key handlers here would make Enter/Space toggle the selection twice. -->
            <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
            <div class="cipo--cursor--pointer cipo--min-width--0 cipo--overflow--hidden" (click)="selectNode(node)">
                <p class="m-a-0 cipo--text--ellipsed" [title]="node.name">{{ node.name }}</p>
                @if (isLoadingChildren(node.explorerKey)) {
                    <ngx-skeleton-loader [theme]="{ width: '100%', height: '12px', margin: '10' }" />
                }
            </div>
        </cdk-tree-node>
    </cdk-tree>
    @if (!filteredDatasource().length) {
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px" data-testid="folder-tree-empty">
            <p class="cipo-text--black-500 m-a-0">
                {{ (isSearching() ? "fileExplorer.noFoldersMatch" : "fileExplorer.noFolders") | translate }}
            </p>
            @if (canAddFolder() && !isSearching()) {
                <button
                    mat-button
                    color="primary"
                    type="button"
                    data-testid="folder-tree-add-folder"
                    (click)="addFolder.emit()">
                    {{ "fileExplorer.addNewFolder" | translate }}
                </button>
            }
        </div>
    }
}
